<div *ngIf="model">
    <div class="flex" [ngClass]="view == 'columns' ? 'flex-row' : 'flex-col'">
      <ng-template ngFor let-lang="$implicit" [ngForOf]="languages" let-i="index">
        
        <div class="flex-1 p-2">
          <div *ngIf="!getTtsVoiceId(lang)">
            <div class="text-danger">No voice available</div>
          </div>

          <div *ngIf="getTtsVoiceId(lang)">
            <div class="lang-label">Voice {{lang}}</div>
            <nb-badge status="danger" class="diff-el" text="Show diff" *ngIf="didChange[lang] && templateModel"
                [nbTooltip]="templateModel[lang]" nbTooltipPlacement="top" [nbTooltipStatus]="danger">
            </nb-badge>
            <div class="text-center">
              <div>
                <div class="m-1" *ngIf="templateModelVoices[lang]">
                  From template
                  <audio controls="controls" [src]="templateModelVoices[lang].fileURL+'?time='+templateModelVoices[lang].lastUpdate" class="w-100">
                    Your browser does not support the audio element.
                  </audio>
                  <div *ngIf="templateModelVoices[lang].ttsVoiceId !== getTtsVoiceId(lang)" class="text-danger">TTS voice mismatch</div>
                  <div *ngIf="templateModelVoices[lang].textHash !== getTextHash(lang)" class="text-danger">Text mismatch</div>
                </div>
                <div class="m-1" *ngIf="modelVoices[lang]">
                  Current audio
                  <audio controls="controls" [src]="modelVoices[lang].fileURL+'?time='+modelVoices[lang].lastUpdate" class="w-100">
                    Your browser does not support the audio element.
                  </audio>
                  <div *ngIf="modelVoices[lang].ttsVoiceId !== getTtsVoiceId(lang)" class="text-danger">TTS voice mismatch</div>
                  <div *ngIf="modelVoices[lang].textHash !== getTextHash(lang)" class="text-danger">Text mismatch</div>
                </div>
                <div class="m-1">
                  <button nbButton [nbSpinner]="generatingVoice" nbSpinnerStatus="primary" status="primary" size="tiny" (click)="generateVoice(lang)">
                    Generate preview
                  </button>
                  <button nbButton status="primary" size="tiny" (click)="playVoice(lang)" *ngIf="voicePreview[lang]">
                    Play preview ({{getPreviewSize(lang)}})
                  </button>
                </div>
                <div class="m-1" *ngIf="voicePreview[lang]">
                  <button nbButton [nbSpinner]="saving" nbSpinnerStatus="primary" status="primary" size="tiny" (click)="saveVoice(lang)">
                    Save voice
                  </button>
                </div>
                <ng-container *ngIf="progress as percent">
                  <div class="row">
                      <progress [value]="percent" max="100"></progress>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="editor-action">
          <button nbButton class="btn p-0 btn-save btn-rounded ml-3 " [nbContextMenu]="applyMenu" [nbContextMenuTag]="'multilang-editor'+attribute" *ngIf="!editMode && showApplyChanges">
            <nb-icon icon="code-download-outline" pack="eva"></nb-icon>
          </button>
      </div>
    </div>
    <div class="row w-100 d-flex align-items-center p-2" *ngIf="changeCount>0 && templateModel">
      <div class="col">
        <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate()">Update from template</button>
      </div>
    </div>
</div>